import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Input,
  useToast,
  Text,
} from '@chakra-ui/react'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import { firebase } from '../firebaseConfig'

export default function ResetPasswordModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('')
  const [isSending, setIsSending] = useState(false)
  const toast = useToast()
  const bgOuter = 'bg.surface'

  const auth = getAuth(firebase)

  const onEmailChange = (e) => setEmail(e.target.value)

  const onSendReset = async () => {
    setIsSending(true)
    try {
      await sendPasswordResetEmail(auth, email)
      toast({
        title: 'Check your inbox to continue with password reset.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      setEmail('')
      onClose()
    } catch (error) {
      toast({
        title: 'Error sending reset email.',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    } finally {
      setIsSending(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent bg={bgOuter} color="text.primary">
        <ModalHeader>Reset Password</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={2}>Enter your email address to receive reset instructions.</Text>
          <Input
            placeholder="you@example.com"
            value={email}
            onChange={onEmailChange}
            type="email"
            autoFocus
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isSending}>
            Cancel
          </Button>
          <Button
            colorScheme="purple"
            onClick={onSendReset}
            isLoading={isSending}
            isDisabled={!email}
          >
            Send Reset Email
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
